type ImportedImage = string | { src: string };

export const Image = ({
  src,
  alt,
  className,
  ...rest
}: {
  src: any;
  alt: string;
  className?: string;
  [key: string]: any;
}) => {
  return <img src={src} alt={alt} className={className} {...rest} />;
};
